<template>
  <div>
    <div
      class="service__head flex-column flex-sm-row align-items-baseline d-flex align-items-sm-center"
    >
      <div
        class="service__thumb"
        :style="{ backgroundImage: 'url(' + service.image_url + ')' }"
      ></div>
      <div class="d-flex flex-column">
        <h1 class="service__title">
          {{ service.name }}
        </h1>
        <p class="service__descr">{{ service.description }}</p>
      </div>
    </div>
    <div class="service__body">
      <b-tabs content-class="mt-3" class="mt-4" pills>
        <b-tab title="Сервіс" active>
          <div
            v-if="service.files_info && service.files_info.length"
            class="service-files mb-3"
          >
            <h6 class="mb-2">Документи</h6>
            <div
              v-for="(item, i) in service.files_info"
              :key="'fi-' + i"
              class="service-files__item"
            >
              <strong>{{ item.label }}</strong>
              <small v-if="item.description" class="text-muted ml-1">
                — {{ item.description }}
              </small>
              <a
                v-if="item.file && item.file.file_url"
                :href="item.file.file_url"
                target="_blank"
                class="ml-2"
              >
                {{ item.file.file_name || "Завантажити" }}
              </a>
            </div>
          </div>
          <template v-if="service.slug == 'anonymous-corruption-report'">
            <anonymous-corruption-report :s="service" />
          </template>
          <template v-if="service.slug == 'information_request'">
            <information-request :s="service" />
          </template>
          <template v-if="service.slug == 'appeals'">
            <appeals :s="service" />
          </template>
          <template v-if="service.slug == 'dwelling-queue-application'">
            <dwellingQueueApplication :s="service" />
          </template>
          <template v-if="service.slug == 'dwelling-queue-information'">
            <dwellingQueueInformation :s="service" />
          </template>
          <template v-if="service.slug == 'schedule-an-appointment'">
            <scheduleAnAppointment :s="service" />
          </template>
          <template v-if="service.slug == 'social-help-request'">
            <socialHelpReuqest :s="service" />
          </template>
          <template
            v-if="
              service.slug == 'meeting-participation-comission' ||
              service.slug == 'meeting-participation-commitee'
            "
          >
            <meetingParticipationRequest :s="service" />
          </template>
        </b-tab>
        <b-tab title="Інформація" v-if="service.about">
          <div v-html="service.about"></div>
        </b-tab>
        <b-tab title="Опубліковані звернення" v-if="service.slug == 'appeals'">
          <publishedAppeals />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
//services content
import anonymousCorruptionReport from "@/components/local-services/anonymous-corruption-report.vue";
import informationRequest from "@/components/local-services/information-request.vue";
import appeals from "@/components/local-services/send-appeal-to-government.vue";
import dwellingQueueApplication from "@/components/local-services/dwelling-queue-application.vue";
import dwellingQueueInformation from "@/components/local-services/dwelling-queue-info.vue";
import scheduleAnAppointment from "@/components/local-services/schedule-an-appointment.vue";
import socialHelpReuqest from "@/components/local-services/social-help-request.vue";

import publishedAppeals from "@/components/local-services/sub-components/published-appeals.vue";
import meetingParticipationRequest from "@/components/local-services/meeting-participation-request.vue";

export default {
  components: {
    anonymousCorruptionReport,
    dwellingQueueApplication,
    dwellingQueueInformation,
    informationRequest,
    scheduleAnAppointment,
    socialHelpReuqest,
    appeals,
    publishedAppeals,
    meetingParticipationRequest,
  },
  props: ["service"],
  service_tabs: ["info", "faq", "howto"],
};
</script>

<style lang="scss" scoped>
.service-files {
  h6 {
    font-size: 14px;
    color: #838b9d;
  }
  &__item {
    padding: 6px 0;
    font-size: 14px;
    border-bottom: 1px solid #f0f0f0;
    &:last-child {
      border-bottom: none;
    }
    a {
      font-size: 13px;
    }
  }
}
.service {
  &__external-link {
    padding: 12px;
    background: #f4f4f4;
    border-radius: 8px;
  }
  &__title {
    font-size: 32px;
    @media (max-width: 575px) {
      font-size: 24px;
      margin-top: 20px;
    }
  }
  &__descr {
    font-size: 15px;
    color: #424242;
  }
  &__thumb {
    width: 180px;
    min-width: 180px;
    height: 120px;
    background-size: cover;
    background-position: center;
    border-radius: 10px;
    box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.2);
    margin-right: 30px;
    background-color: #e7e7e7;
    border: 2px solid #fff;
  }
}
</style>
